export default {
  install (Vue, options) {
    Vue.prototype.to = function (page, params = {}) {
      return { name: page, params: params };
    }
    Vue.prototype.goTo = function (page, params = {}) {
      this.$router.push(this.to(page, params)).catch(err => {})
    }
  }
}
